import {type IAsset} from '@netx/core-asset-next/schema';
import {getGeneralAssetFileType} from './getGeneralAssetFileType';
import {getDocumentFileTypeAssetInfoLabel} from './getDocumentFileTypeAssetInfoLabel';
import {getMediaFileTypeAssetInfoLabel} from './getMediaFileTypeAssetInfoLabel';
import {getImageFileTypeAssetInfoLabel} from './getImageFileTypeAssetInfoLabel';

export const getAssetFileTypeInfoLabel = ({
	duration,
	fileFormatFamily,
	fileheight,
	filewidth,
	constituentIds,
}: Pick<
	IAsset,
	| 'constituentIds'
	| 'duration'
	| 'fileFormatFamily'
	| 'fileheight'
	| 'filewidth'
>) => {
	switch (getGeneralAssetFileType(fileFormatFamily)) {
		case 'document':
			return getDocumentFileTypeAssetInfoLabel(constituentIds.length);
		case 'media':
			return getMediaFileTypeAssetInfoLabel(duration);
		default:
			//case 'image':
			return getImageFileTypeAssetInfoLabel(filewidth, fileheight);
	}
};

export default getAssetFileTypeInfoLabel;
